const formatDate = (date: string, locale: string = 'default') => {
  const dtf = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });

  const [{ value: day }, , { value: month }, , { value: year }] = (
    dtf as any
  ).formatToParts(new Date(date));

  return `${month} ${day}, ${year}`;
};

export default formatDate;
